import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; 2024 Seccastudio. All Rights Reserved.</p>
    </footer>
  );
};

export default Footer;
